import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { Modal, Box, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  Fragment,
  PopupBody,
  PopupButton,
  PopupHeader,
  SectionTitle,
  ButtonsContainer,
  FieldContainer,
  FormContainer,
  SectionContainer,
} from "./LicensePopup.styled";
import InputField from "../../../../components/formFields/InputField";
import DatePickerField from "../../../../shared/components/DatePickerField";
import {
  useCreateCommunicationMutation,
  useGetNaicMemberQuery,
  useGetLastBodyQuery,
  useGetLicenseDropdownTypesQuery,
} from "../../../../services/InsuranceService";
import SearchableSelect from "../../../../components/formFields/SearchableSelect";
import { LoadingPanel } from "../../../../shared/components/LoadingPanel";
import useFetchWithMsal from "../../../../utils/useFetchWithMsal";
import SelectField from "../../../../shared/components/SelectField";

export const LicensePopup = ({ open, onClose, data, classAPopupOpen, memberKey, addLicense, editLicense }) => {
  const { skip } = useFetchWithMsal();
  const [lastBody, setLastBody] = useState("");  
  const [initialNaicCode, setInitialNaicCode] = useState("");  
  const { data: body, refetch } = useGetLastBodyQuery();
  const { data: naicMembers, isLoading } = useGetNaicMemberQuery("", {});
  const { data: licensesTypes } = useGetLicenseDropdownTypesQuery("", {});
  
  const {
    id,
    licenseType,
    startDate,
    expirationDate,
    user,
    modifyDate,
  } = data;

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    if (naicMembers?.length) setInitialNaicCode(naicMembers[0]);
  }, [naicMembers]);

  const [createCommunication, { isLoading: isCommunicationCreating }] = useCreateCommunicationMutation();

  const initialValues = {
    licenseType: licensesTypes?.find((item) => item.code === licenseType)?.code || "",
    startDate,
    expirationDate,
    user,
    modifyDate,
  };

  const validationSchema = Yup.object().shape({});

  const handleSubmit = (values) => {
    id
    ? editLicense({
      id: id,
      expirationDate: values?.expirationDate || null,
      licenseTypeId: licensesTypes?.find((item) => item.code === values?.licenseType)?.id || "",
      modifyDate: values?.modifyDate,
      startDate: values?.startDate,
      user: values?.user,
      memberKey: memberKey,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    })
    : addLicense({
        expirationDate: values?.expirationDate || null,
        licenseTypeId: licensesTypes?.find((item) => item.code === values?.licenseType)?.id || "",
        modifyDate: values?.modifyDate,
        startDate: values?.startDate,
        user: values?.user,
        memberKey: memberKey,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      }) 
    onClose();
  };

  const getInputComponent = (item) => {
    switch (item?.type) {
      case "text":
        return <FieldContainer><InputField name={item.name} label={item.label} fullWidth /></FieldContainer>;
      case "number":
        return <FieldContainer><InputField name={item.name} label={item.label} fullWidth type="number" /></FieldContainer>;
      case "multiline":
        return <FieldContainer><InputField name={item.name} label={item.label} fullWidth multiline type="textarea" /></FieldContainer>;
      case "date":
        return <FieldContainer><DatePickerField name={item.name} label={item.label} width="100%" /></FieldContainer>;
      case "searchableSelect":
        return <FieldContainer><SearchableSelect name={item.name} label={item.label} fullWidth options={naicMembers} /></FieldContainer>;
      case "licenseTypeSelect":
        return <FieldContainer>
          <SelectField
            name={item.name}
            label={item.label}
            data={licensesTypes}
            fullWidth
            isDisabled={item.isDisabled}
          />
        </FieldContainer>;  
      default:
        return null;
    }
  };
  return (
    <Modal open={open} onClose={onClose}>
      <PopupBody>
        <Fragment>
          <PopupHeader>
            <Box>
              <SectionTitle>
                {!data?.id ? 'New License' : 'Edit License'}
              </SectionTitle>
            </Box>
            <PopupButton aria-label="close" onClick={onClose}>
              <CloseIcon />
            </PopupButton>
          </PopupHeader>
          <Box sx={{ p: 1 }}>
            <Formik
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validationSchema={validationSchema}
              enableReinitialize
            >
              {({ values, setFieldValue }) => (
                <Form>
                  {(isLoading || isCommunicationCreating) && <LoadingPanel />}
                  <FormContainer>
                      {getInputComponent({ name: "licenseType", label: "License type:", type: "licenseTypeSelect" })}
                      {getInputComponent({ name: "startDate", label: "Start date:", type: "date" })}
                      {getInputComponent({ name: "expirationDate", label: "Expiration date:", type: "date" })}
                      {/* {getInputComponent({ name: "user", label: "User:", type: "text" })}
                      {getInputComponent({ name: "modifyDate", label: "Modify date:", type: "date" })} */}
                      <ButtonsContainer>
                        <Button variant="outlined" type="submit">Save</Button>
                        <Button variant="outlined" type="reset" onClick={onClose}>Cancel</Button>
                      </ButtonsContainer>
                  </FormContainer>
                </Form>
              )}
            </Formik>
          </Box>
        </Fragment>
      </PopupBody>
    </Modal>
  );
};
